module.exports = __webpack_public_path__ + "static/media/DRpoweredby.db153317.png";